import { useContext, useEffect } from 'react';
import { AuthContext } from '../../../../context/auth';
import { getUserDetailsService, updateUserDetailsService } from '../../../../services/auth.service';
import { planHasSequentialSteps, mergeOnboardingRefreshIntoAuthUser } from '../constants/onboardingSteps.config';

/**
 * Onboarding: viewing the impact dashboard is Step 3's completion signal — but only for
 * plans that actually define numbered/sequential steps (currently just enterprise_p0).
 * Guards other users from an irrelevant write to their onboarding_steps_completed.
 * Runs once on mount.
 */
const useCompleteImpactOnboardingStep = () => {
    const { authUser, setAuthUser } = useContext(AuthContext);

    useEffect(() => {
        if (!planHasSequentialSteps(authUser?.dq_pro_plan?.plan_key)) return;
        updateUserDetailsService({ complete_onboarding_step: 3 })
            .then(() => getUserDetailsService())
            .then(res => {
                const refreshedUser = res?.data?.user || res?.data;
                // Merge ONLY onboarding progress — a full replace drops
                // login-time session fields (see mergeOnboardingRefreshIntoAuthUser).
                const merged = mergeOnboardingRefreshIntoAuthUser(authUser, refreshedUser);
                if (merged !== authUser) setAuthUser(merged);
            })
            .catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useCompleteImpactOnboardingStep;
